import { useState, useEffect } from 'react';
import fetchers from '../functions/fetch';
import { user } from '../mocks/usersMocks/usersStore';
import { post } from '../mocks/postsMocks/postsStore';

const useUser: (user_id: string) => { user: user, posts: post[] } | undefined = (user_id) => {
  const [result, setResult] = useState<{ user: user, posts: post[] } | undefined>(undefined);
  useEffect(() => {
    fetchers.get_user({ user_id }).then((res) => {
      if (res.status === 200) {
        const user = res.data;
        fetchers.get_user_posts({ user_id }).then((res2) => {
          if (res2.status === 200) {
            const posts = res2.data.posts;
            setResult({ user, posts });
          }
        });
      }
    });
  }, [user_id]);
  return result;
};

export default useUser;
